import React from "react";
import { useState } from "react";
import { Toast } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { agentSliceAction } from "../../../store/agentSlice";
import { BiCommentError } from "react-icons/bi";


const SoftphoneError = () => {
    const dispatch = useDispatch()
    const softphoneError = useSelector((state:any)=>{return state.agentSlice.softphoneError})
    const [showError, setShowError] = useState(true);

    const toggleShowError = () => {
        setShowError(!showError);
        dispatch(agentSliceAction.setSoftphoneError(""))
    } 
    return (
        <React.Fragment>
            {softphoneError && 
                <Toast show={showError} onClose={toggleShowError}>
                    <Toast.Header className="bg-danger text-white">
                        <strong className="me-auto">Softphone error</strong>
                    </Toast.Header>
                    <Toast.Body className="text-danger"><BiCommentError className="me-2" />{softphoneError}</Toast.Body>
                </Toast>
            }
        </React.Fragment>
    )
}

export default SoftphoneError;